export enum WrapperStatus {
  Valid = 'valid',
  Loading = 'loading',
  Error = 'error',
  None = 'none',
}

export enum ContentVisibility {
  Visible = 'visible',
  Hidden = 'hidden',
}

export interface WrapperConfig {
  status: WrapperStatus;
  text: string;
}
